module.exports = __webpack_public_path__ + "static/img/bonus.a4b2189.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/innerMessage/bonus.svg
// module id = v1Ok
// module chunks = 0